import {
  createNaturalPaperRotation,
  type ImagePresentation,
  type RandomSource,
} from '@blocksuite/affine-model';

export type DroppedImageAppearance = {
  presentation: ImagePresentation;
  rotate: number;
};

/** Resolves the last-selected image style and its creation-time rotation. */
export function createDroppedImageAppearance(
  presentation: ImagePresentation | undefined,
  random: RandomSource = Math.random
): DroppedImageAppearance {
  const resolvedPresentation = presentation ?? 'default';
  return {
    presentation: resolvedPresentation,
    rotate:
      resolvedPresentation === 'polaroid'
        ? createNaturalPaperRotation(random)
        : 0,
  };
}
